import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const FOUNDERS = [
  { name: "Pratyusha", role: "Brand", img: "https://api.dicebear.com/9.x/lorelei/svg?seed=Pratyusha&backgroundColor=E8F2EC" },
  { name: "Ajay", role: "Operations & Tech", img: "https://api.dicebear.com/9.x/lorelei/svg?seed=Ajay&backgroundColor=E8F2EC" },
];

export default function AboutMini() {
  return (
    <section className="bg-[#FAFAF8] py-16 md:py-20" data-testid="about-mini-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <div className="kicker mb-3">About Appy Stays</div>
            <h2 className="font-sora text-3xl md:text-4xl font-semibold tracking-tight text-[#0E2E24] leading-[1.08] max-w-2xl">
              We rebuild farmhouses into booking brands — and run them ourselves.
            </h2>
            <p className="mt-4 max-w-xl text-[#5B6B63] leading-relaxed">
              Founded in Hyderabad. 30 curated properties. 10 of them fully managed by us. A small, senior, in-house team — from photo to host desk.
            </p>
            <Link
              to="/about"
              className="mt-5 inline-flex items-center gap-1.5 text-[#1F5A43] font-sora font-medium hover:text-[#0E2E24]"
              data-testid="about-mini-link"
            >
              Read our story <ArrowRight size={15} />
            </Link>
          </div>

          <div className="lg:col-span-5">
            <div className="flex items-center gap-5">
              <div className="flex -space-x-3">
                {FOUNDERS.map((f) => (
                  <div key={f.name} className="h-14 w-14 rounded-full overflow-hidden border-2 border-[#FAFAF8] bg-[#E8F2EC]">
                    <img src={f.img} alt={f.name} className="img-cover" />
                  </div>
                ))}
              </div>
              <div className="font-sora text-sm">
                <div className="font-semibold text-[#0E2E24]">Pratyusha · Ajay</div>
                <div className="text-[#5B6B63]">Co-founders, Appy Stays</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
